// extracted by mini-css-extract-plugin
export default {"title":"section-title_title__jGIc7"};